import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { monthOptions, yearOptions } from "../../../config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import {
  mapPartInOutYTDToTable,
  getTableConfig,
  buildExcelRequestBodyPartInOutYTD,
} from "./config";
import moment from "moment";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { saveAs } from "file-saver";

export default class LaporanPartYTD extends Component {
  constructor(props) {
    super(props);
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      year: yearOptions.find((item) => item.value === this.currentYear),
      tableConfig: getTableConfig(this.currentYear),
      dataTable: [],
    };
  }

  componentDidMount() {}

  handleChangeSearchValue = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "year" && {
        tableConfig: getTableConfig(value?.value),
      }),
    }));
  };

  fetchData = async () => {
    const { onTriggerLoading, search } = this.props;
    const { year } = this.state;

    if (!search) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPartsInOutYearToDate,
      menuName: "Dashboard Kabeng Keatas - Laporan Part In - Out YTD",
      args: {
        kodeCabang: search,
        year: year?.value,
      },
    });

    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: mapPartInOutYTDToTable(res.data.data),
      });
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    const { onTriggerLoading } = this.props;
    const { year, dataTable } = this.state;
    onTriggerLoading();

    try {
      const reqBody = buildExcelRequestBodyPartInOutYTD({
        year,
        dataTable,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName: "Dashboard Level Mekanik dan SA - Laporan Part In Out YTD",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      onTriggerLoading();
    }
  };

  render() {
    const { year, dataTable, tableConfig } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginTop: "5px" }}
            onClick={this.handleSearch}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <p className="margin-bottom-20px" style={{ fontWeight: "bold" }}>
          LAPORAN PARTS IN - OUT YEAR TO DATE
        </p>
        <SimpleDataTable
          data={dataTable}
          columns={tableConfig}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={this.handlePrint}
          />
        </FlexView>
      </React.Fragment>
    );
  }
}
